import axios from 'axios';

export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://ghostie-api.onrender.com').replace(/\/$/, '');
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
